import React, { useRef, useState } from 'react';
import { Manager, Reference, Popper } from 'react-popper';
// import styles from '../index.module.scss';
import useOutsideClick from '../../../hooks/useOutsideClick';

const DropdownCommon = ({
  placement,
  position,
  children,
  togglerContent,
  activeTogglerClassName,
  dropdownContentStyles,
  togglerStyles,
  dropdownMainWrapperStyles,
}) => {
  const [visible, setVisibility] = useState(false);
  const componentRef = useRef();

  const handleDropdownClick = () => {
    setVisibility(!visible);
  };

  useOutsideClick(componentRef, () => {
    if (visible) setVisibility(false);
  });

  return (
    <div className={dropdownMainWrapperStyles} ref={componentRef}>
      <Manager>
        <Reference>
          {({ ref }) => (
            <button
              className={`
              ${togglerStyles}
              ${visible && activeTogglerClassName}
              btn
            `}
              type="button"
              ref={ref}
              onClick={handleDropdownClick}
            >
              {togglerContent}
            </button>
          )}
        </Reference>
        <Popper placement={placement} position={position}>
          {({ ref, style }) => (
            <div
              ref={ref}
              style={{
                ...style,
                zIndex: visible ? '1' : '-999',
                opacity: visible ? '1' : '0',
              }}
              className={`
              ${dropdownContentStyles}
              ${visible && activeTogglerClassName}
            `}
            >
              {children}
            </div>
          )}
        </Popper>
      </Manager>
    </div>
  );
};

DropdownCommon.defaultProps = {
  placement: 'bottom',
  position: 'bottom',
  dropdownMainWrapperStyles: '',
  dropdownContentStyles: '',
  togglerStyles: '',
  activeTogglerStyles: '',
  togglerContent: () => { },
};

export default DropdownCommon;
